// extracted by mini-css-extract-plugin
module.exports = {"calendar":"Calendar_calendar__1HNTl","month":"Calendar_month__2_tqO","pill":"Calendar_pill__1MGhT"};